const privateStorage = window.localStorage;

/**
 * Represents a Storage strategy
 * For now it only uses localStorage
 * @constructor
 */
class Storage {
    /**
     * Stores an item
     * @param {string} key - key with which to store the desired item
     * @param {string} item - Item to store
     */
    store(key, item) {
        privateStorage.setItem(key, item);
    }

    /**
     * Gets an item
     * @param {string} key - key with which the item was stored
     * @returns {string} The item
     */
    get(key) {
        return privateStorage.getItem(key);
    }

    /**
     * Checks if the store possesses an item under given key
     * @param {string} key - key with which the item was stored
     * @returns {bool} Does the item exist?
     */
    hasItem(key) {
        return !!this.get(key);
    }

    /**
     * Removes an item from the store
     * @param {string} key - key with which the item was stored
     */
    remove(key) {
        privateStorage.removeItem(key);
    }

    /**
     * Gets an item and removes it
     * @param {string} key - key with which the item was stored
     * @param {*} defaultValue - Value to return if the key is not found on storage
     * @returns {string} - The item
     */
    pop(key, defaultValue = undefined) {
        if (!this.hasItem(key)) {
            return defaultValue;
        }

        let item = this.get(key);
        this.remove(key);
        return item;
    }
}

export default new Storage();
